import React from "react";
import { Box } from "@mui/material";
import AdminSlidingPlay from "./AdminSlidingPlay";

export default function AdminSlidingPlayMain() {
    return (
        <Box>
            <AdminSlidingPlay />
        </Box>
    );
}
